function initCalc() {
  const isPresent = document.querySelector(".c-calc-select");
  if (!isPresent) {
    return;
  }

  const calc = document.querySelector(".c-calc-select");

  function calc_V() {
    const v = calc.options[calc.selectedIndex].dataset.v;
    const array = v.split(",");
    const final = array.map((el) => el.trim());

    const listItems = final.reduce((result, item) => {
      // Add a string to the result for the current item. This syntax is using template literals.
      if (item === "0") {
        // Add a string to the result for the current item. This syntax is using template literals.
        result += `<li></li>`;
      } else {
        // Add a string to the result for the current item. This syntax is using template literals.
        result += `<li>${item}</li>`;
      }

      // Always return the result in the reduce callback, it will be the value or result in the next iteration.
      return result;
    }, ""); // The '' is an empty string, it is the initial value result.
    // Get the element from the DOM in which to display the list, this should be an ul or ol element.
    const resultElement = document.querySelector(".c-calc-v");

    // Set the inner HTML
    resultElement.innerHTML = listItems;
  }

  function calc_ir() {
    const ir = calc.options[calc.selectedIndex].dataset.ir;
    const array = ir.split(",");
    const final = array.map((el) => el.trim());

    const listItems = final.reduce((result, item) => {
      // Add a string to the result for the current item. This syntax is using template literals.
      if (item === "0") {
        // Add a string to the result for the current item. This syntax is using template literals.
        result += `<li></li>`;
      } else {
        // Add a string to the result for the current item. This syntax is using template literals.
        result += `<li>${item}</li>`;
      }

      // Always return the result in the reduce callback, it will be the value or result in the next iteration.
      return result;
    }, ""); // The '' is an empty string, it is the initial value result.
    // Get the element from the DOM in which to display the list, this should be an ul or ol element.
    const resultElement = document.querySelector(".c-calc-ir");

    // Set the inner HTML
    resultElement.innerHTML = listItems;
  }

  function calc_f() {
    const f = calc.options[calc.selectedIndex].dataset.f;
    const array = f.split(",");
    const final = array.map((el) => el.trim());

    const listItems = final.reduce((result, item) => {
      // Add a string to the result for the current item. This syntax is using template literals.
      if (item === "0") {
        // Add a string to the result for the current item. This syntax is using template literals.
        result += `<li></li>`;
      } else {
        // Add a string to the result for the current item. This syntax is using template literals.
        result += `<li>${item}</li>`;
      }

      // Always return the result in the reduce callback, it will be the value or result in the next iteration.
      return result;
    }, ""); // The '' is an empty string, it is the initial value result.
    // Get the element from the DOM in which to display the list, this should be an ul or ol element.
    const resultElement = document.querySelector(".c-calc-f");

    // Set the inner HTML
    resultElement.innerHTML = listItems;
  }

  function calc_b() {
    const b = calc.options[calc.selectedIndex].dataset.b;
    const array = b.split(",");
    const final = array.map((el) => el.trim());

    const listItems = final.reduce((result, item) => {
      if (item === "0") {
        // Add a string to the result for the current item. This syntax is using template literals.
        result += `<li></li>`;
      } else {
        // Add a string to the result for the current item. This syntax is using template literals.
        result += `<li>${item}</li>`;
      }

      // Always return the result in the reduce callback, it will be the value or result in the next iteration.
      return result;
    }, ""); // The '' is an empty string, it is the initial value result.
    // Get the element from the DOM in which to display the list, this should be an ul or ol element.
    const resultElement = document.querySelector(".c-calc-b");

    // Set the inner HTML
    resultElement.innerHTML = listItems;
  }

  calc_V();
  calc_ir();
  calc_f();
  calc_b();

  calc.addEventListener("change", function () {
    calc_V();
    calc_ir();
    calc_f();
    calc_b();

    document.querySelector(".c-calc-custom-select-value").innerHTML =
      calc.value;

    document.querySelector(".c-calc-results-wrap").dataset.currentValue =
      calc.value;
  });

  function tooltips() {
    const isPresent = document.querySelector(".c-calc-tooltip");
    if (!isPresent) {
      return;
    }

    document.addEventListener("click", (e) => {
      const tooltip = e.target.closest(".c-calc-tooltip");
      if (tooltip) {
        tooltip.classList.toggle("open");
        tooltip.nextElementSibling.classList.toggle("visible");
      }
    });
  }

  tooltips();
}

export default initCalc;
